/**
 * The sign-up form's "How many endpoints do you manage?" dropdown. Required, with no option
 * selected until the visitor picks one; the answer goes to the HubSpot trial form
 * (how_many_endpoints_need_to_manage__c) and the Salesforce lead
 * (How_many_endpoints_need_to_manage__c), so the option values are the exact strings those
 * fields expect.
 */

export const ENDPOINTS_TO_MANAGE_OPTIONS = ['0-100', '101-250', '251-500', '501-1000', '1001 and above'] as const

export type EndpointsToManage = (typeof ENDPOINTS_TO_MANAGE_OPTIONS)[number]

export const ENDPOINTS_TO_MANAGE_LABEL = 'How many endpoints do you manage?'
export const ENDPOINTS_TO_MANAGE_ERROR_TEXT = 'Please choose how many endpoints you need to manage.'

export function isEndpointsToManage(value: string): value is EndpointsToManage {
  return (ENDPOINTS_TO_MANAGE_OPTIONS as readonly string[]).includes(value)
}
